import {Component, computed, Input, OnInit, Signal} from '@angular/core';

import {BreadCrumb, LogoAreaComponent} from '../logo-area/logo-area.component';
import {Airline} from '../../types-workflow';
import {Organization} from '../../types-repository';
import {HeadlineSectionComponent} from '../headline-section/headline-section.component';
import {AirlineSelectComponent} from '../airline-select/airline-select.component';
import {ContextService} from '../../services/context.service';

@Component({
  selector: 'app-workflows',
  templateUrl: './workflows.component.html',
  styleUrls: ['./workflows.component.scss'],
  providers: [],
  imports: [LogoAreaComponent, HeadlineSectionComponent, AirlineSelectComponent]
})
export class WorkflowsComponent {
  organization: Signal<Organization>;
  constructor(private contextService: ContextService) {
    this.organization = this.contextService.organization;
  }
}
